module.exports = __webpack_public_path__ + "static/img/jjMerchant.ff16868d.png";